import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import RootReducer from './RootReducer';
// import { BroadcastMiddleware } from './Broadcast';

const persistConfig = {
  key: 'root',
  storage: storageSession
};

const persistedReducer = persistReducer(persistConfig, RootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    // getDefaultMiddleware({ serializableCheck: false }).concat(BroadcastMiddleware),
    getDefaultMiddleware({ serializableCheck: false }),
  // thunk is already included by default in RTK
  devTools: process.env.NODE_ENV !== 'production'
});

export const persistor = persistStore(store);
